import React from "react";
import PropTypes from "prop-types";
import { header, text } from "./EmptyStates.module.scss";

// Avoid using this component directly. Please refer to the EmptyStates storybook folder for higher level reusable components
const EmptyStateMessage = ({ width, headerFontSize, messageFontSize, headerMessage, message }) => (
  <div style={{ width: width }} className="d-flex align-items-center justify-content-center flex-column text-center">
    <span style={{ fontSize: headerFontSize }} className={header}>{headerMessage}</span>
    <span style={{ fontSize: messageFontSize }} className={text}>{message}</span>
  </div>
);

EmptyStateMessage.propTypes = {
  messageFontSize: PropTypes.string.isRequired,
  headerFontSize: PropTypes.string.isRequired,
  width: PropTypes.string.isRequired,
  headerMessage: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired
};

export default EmptyStateMessage;
